// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"313f06c3","455":"57c7db0a"}[chunkId] + ".chunk.js";
};